import React from 'react';
import { Box, Typography, IconButton, Grid } from '@mui/material';
import { styled } from '@mui/system';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const FooterContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#333',
  color: 'white',
  padding: '20px 50px',
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    padding: '20px',
  },
}));

const SocialIcons = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  gap: '15px',
  marginTop: '10px',
}));

const FooterGrid = styled(Grid)(({ theme }) => ({
  marginTop: '20px',
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    textAlign: 'center',
  },
}));

const FooterItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '10px',
  marginBottom: '15px', // Add spacing between items
}));

const FooterBottom = styled(Box)(({ theme }) => ({
  marginTop: '20px',
  borderTop: '1px solid #555',
  paddingTop: '10px',
}));

function Footer() {
  return (
    <FooterContainer>
      <Typography variant="h6" gutterBottom>
        Follow Us
      </Typography>
      <SocialIcons>
        <IconButton color="inherit" target="_blank" href="https://www.facebook.com/share/16P5pHUkpd/?mibextid=wwXIfr">
          <FacebookIcon />
        </IconButton>
        <IconButton color="inherit" target="_blank">
          <TwitterIcon />
        </IconButton>
        <IconButton color="inherit" target="_blank">
          <InstagramIcon />
        </IconButton>
        <IconButton color="inherit" target="_blank">
          <LinkedInIcon />
        </IconButton>
        <IconButton color="inherit" target="_blank">
          <EmailIcon />
        </IconButton>
      </SocialIcons>

      {/* <FooterGrid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <FooterItem>
            <LocationOnIcon />
            <Typography variant="body1">
              123 Main Street, City, Country
            </Typography>
          </FooterItem>
        </Grid>
        <Grid item xs={12} sm={4}>
          <FooterItem>
            <PhoneIcon />
            <Typography variant="body1">
              +123 456 7890
            </Typography>
          </FooterItem>
        </Grid>
        <Grid item xs={12} sm={4}>
          <FooterItem>
            <EmailIcon />
            <Typography variant="body1">
              contact@company.com
            </Typography>
          </FooterItem>
        </Grid>
      </FooterGrid> */}

      <FooterBottom>
        <Typography variant="body2">
          &copy; {new Date().getFullYear()} Your Company. All rights reserved.
        </Typography>
      </FooterBottom>
    </FooterContainer>
  );
}

export default Footer;